import React, { useState, useEffect } from "react";
import logo from "../../assets/images/brandIcon.svg";
import logoText from "../../assets/images/logoText.svg";
import Loader from "../../modals/Loader";
import { Link } from "react-router-dom";
import "./logIn.css";
import { useDispatch } from "react-redux";
import Doctor from "../../assets/images/signupImageWeb.png";
import DoctorMobile from "../../assets/images/doctorMobile.png";

import JobIcon from "../../assets/images/jobIcon";
import StaffIcon from "../../assets/images/staffIcon";
import StaffSignUp from "../staffSignUp/staffSignUp";

const SignUp = ({ setCurPos, history }) => {
  const dispatch = useDispatch();
  const [navTo, setNavTo] = useState(false);
  const [hospitalSelected, setHospitalSelected] = useState(false);
  const [staffSelected, setStaffSelected] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [card, setCard] = useState(false);
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [setCurPos]);

  useEffect(() => {
    const img = new Image();
    img.src = Doctor;
    img.onload = () => setIsImageLoaded(true);
  }, []);
  const selectHospital = () => {
    window.localStorage.removeItem("first_name");
    window.localStorage.removeItem("last_name");
    window.localStorage.removeItem("email");
    window.localStorage.removeItem("phone");
    window.localStorage.removeItem("password");
    window.localStorage.removeItem("repassword");
    window.localStorage.removeItem("role");
    window.localStorage.removeItem("ein");
    window.localStorage.removeItem("institution_name");
    window.localStorage.removeItem("institution_size");
    window.localStorage.removeItem("institution_website");
    window.localStorage.removeItem("zip_code");
    window.localStorage.removeItem("hoscity");
    window.localStorage.removeItem("hosstate");
    window.localStorage.removeItem("hosstreet_address");
    setHospitalSelected(true);
    setStaffSelected(false);
    dispatch({ type: "RESET_STEPS" });
    setNavTo("/staffSignUp");
  };

  const selectStaff = () => {
    window.localStorage.removeItem("first_name");
    window.localStorage.removeItem("last_name");
    window.localStorage.removeItem("email");
    window.localStorage.removeItem("phone");
    window.localStorage.removeItem("password");
    window.localStorage.removeItem("repassword");
    window.localStorage.removeItem("role");
    window.localStorage.removeItem("ein");
    window.localStorage.removeItem("institution_name");
    window.localStorage.removeItem("institution_size");
    window.localStorage.removeItem("institution_website");
    window.localStorage.removeItem("zip_code");
    window.localStorage.removeItem("hoscity");
    window.localStorage.removeItem("hosstate");
    window.localStorage.removeItem("hosstreet_address");
    setHospitalSelected(false);
    setStaffSelected(true);
    dispatch({ type: "RESET_STEPS" });
    setNavTo("/hospSignUp_1");
  };

  const navToPage = () => {
    if (navTo) {
      setShowLoader(true);
      setTimeout(() => {
        history.push(navTo);
        setShowLoader(false);
      }, 1000);
    }
  };
  const render = () => {
    if (card === 0) return <StaffSignUp />;
  };

  return (
    <div
      className="d-flex h-screen justify-center "
      style={{ height: "100vh" }}
    >
      <div className="flex gap-[100px] items-center w-full px-4 md:!px-7 justify-center  max-w-[1440px] max-h-[] ">
        <div className="w-full  md:w-[50%]  hidden  lg:flex justify-end items-center  ">
          <div className="max-w-[720]">  <img
            alt="img"
            src={Doctor}
            style={{
              height: "94vh",
              width: "100%",
              display: "block",
              margin: "0 auto",
              transition: "filter 0.3s ease",
              filter: isImageLoaded ? "none" : "blur(10px)",
            }}
          /></div>

        </div>
        {/* signUp for job and staff */}
        {
          <div
            className="  max-h-[90vh] h-auto w-full md:w-[50%]  px-0 md:px-6
"
          >
            {/* <p className="flex items-center justify-center">
            <img alt="img" src={logo} className="logInLogo" />
          </p> */}
          <div className="max-w-[500px]"> <div className="flex items-center justify-center  gap-2  md:gap-4">
              <img alt="img" src={logo} className="brandLogo" />
              <img alt="img" src={logoText} className="logInLogo" />
            </div>
            <div className="lg:hidden mt-4  flex items-center justify-center ">
              <img
                alt="img"
                src={DoctorMobile}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="flex items-center  flex-col justify-center gap-7">
              <div className="logIn_txt1 font-semibold text-2xl mt-4 font-inter ">
                Create Account
              </div>
            </div>

            <div className="logIn_body mt-3 w-auto  flex flex-col gap-3">
              <div className="logIn_txt2 text-base ">
                What are you looking for on LinkHealthStaff?
              </div>
              <div
                className="flex flex-col gap-2
            "
              >
                <div
                  className={`  col signUp_item cursor-pointer ${
                    hospitalSelected ? "signUp_item_selected" : ""
                  } items-center gap-6 px-4`}
                  onClick={selectHospital}
                >
                  <JobIcon
                    color={hospitalSelected ? "white" : "#73C7A9"} // Change fill color to white if selected
                    strokeColor={hospitalSelected ? "white" : "#73C7A9"} // Change stroke color to white if selected
                    className="w-[40px] h-[40px]" // Set the icon size
                  />
                  <div
                    className="flex flex-col justify-center"
                    style={{ height: "80px" }}
                  >
                    <p className="font-inter font-semibold text-2xl">Job</p>
                    <p className="font-inter font-normal text-base">
                      Healthcare Job Seeker
                    </p>
                  </div>
                </div>
                <div
                  className={`
                col
                signUp_item
                ${staffSelected ? "signUp_item_selected" : ""}
                cursor-pointer
             items-center gap-6 px-4  `}
                  onClick={selectStaff}
                >
                  <StaffIcon
                    color={staffSelected ? "white" : "#73C7A9"} // Fill color: white if selected, else default color
                    strokeColor={staffSelected ? "white" : "#73C7A9"} // Stroke color: white if selected, else default color
                    className="w-[40px] h-[40px]" // Customize the size
                  />
                  <div
                    className="flex flex-col justify-center "
                    style={{ height: "80px" }}
                  >
                    <p className="font-inter font-semibold text-2xl">Staff</p>
                    <p className="font-inter font-normal text-base">
                      Seeking Staff for Healthcare
                    </p>
                  </div>
                </div>
              </div>
              <div
                className={
                  !navTo ? "logIn_button h-[58px]  logIn_button_disabled !font-inter text-base font-semibold" : "logIn_button !font-inter h-[58px] text-base font-semibold"
                }

                onClick={navToPage}
              >
                {showLoader ? <Loader /> : "Continue"}
              </div>

              <p className="font-normal text-lg font-inter text-center mt-4">
                Already have an account?{" "}
                <Link className="text-[#73C7A9]" to="/login">
                  Log in
                </Link>{" "}
              </p>

              {/* <Link
              className="logIn_button signUp_button mt-3 hover:!text-[#73C7A9] "
              to={"/logIn"}
            >
              {" "}
              LOG IN
            </Link> */}
            </div></div>

          </div>
        }
        {/* <StaffSignUp/> */}
      </div>
    </div>
  );
};

export default SignUp;
